// This file is auto-generated by @hey-api/openapi-ts

import type {
    DeleteInterviewsIdInterviewRoundInterviewRoundIdResponse,
    GetAdminCompaniesIdCreditsLedgerResponse,
    GetAdminCompaniesIdResponse,
    GetAdminCompaniesResponse,
    GetAuthMyCompaniesResponse,
    GetInterviewsIdResponse,
    GetInterviewsResponse,
    GetJobApproversResponse,
    GetOffersApproveResponse,
    GetOffersResponse,
    GetSettingsCommunicationTemplatesIdResponse,
    GetTemporalIntegrationsResponse,
    GetTemporalScreeningCallResponse,
    PatchAdminCompaniesIdArchiveResponse,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponse,
    PostAdminOrganizationsResponse,
    PostCompanyConfigResponse,
    PostInterviewsIdInterviewRoundResponse,
    PostJobApplicationsIdResponse,
    PostJobApproversResponse,
    PostSettingsCommunicationTemplatesResponse,
    PutAdminCompaniesIdResponse,
    PutCompanyConfigResponse,
    PutInterviewsIdInterviewRoundResponse,
    PutInterviewsIdResponse,
    PutOffersDocumentsResponse,
    PutOffersResponse,
    PutSettingsCommunicationTemplatesIdResponse,
    PutTemporalScreeningCallResponse,
} from './types.gen'

export const getAdminCompaniesResponseTransformer = async (data: any): Promise<GetAdminCompaniesResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    if (data.data.archivedAt) {
        data.data.archivedAt = new Date(data.data.archivedAt)
    }
    if (data.data.config) {
        data.data.config.createdAt = new Date(data.data.config.createdAt)
        data.data.config.updatedAt = new Date(data.data.config.updatedAt)
    }
    return data
}

export const postAdminOrganizationsResponseTransformer = async (data: any): Promise<PostAdminOrganizationsResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    if (data.data.archivedAt) {
        data.data.archivedAt = new Date(data.data.archivedAt)
    }
    return data
}

export const getAdminCompaniesIdResponseTransformer = async (data: any): Promise<GetAdminCompaniesIdResponse> => {
    data.data.company.createdAt = new Date(data.data.company.createdAt)
    data.data.company.updatedAt = new Date(data.data.company.updatedAt)
    if (data.data.billingSubscription) {
        if (data.data.billingSubscription.currentPeriodEnd) {
            data.data.billingSubscription.currentPeriodEnd = new Date(data.data.billingSubscription.currentPeriodEnd)
        }
        data.data.billingSubscription.createdAt = new Date(data.data.billingSubscription.createdAt)
        data.data.billingSubscription.updatedAt = new Date(data.data.billingSubscription.updatedAt)
    }
    return data
}

export const putAdminCompaniesIdResponseTransformer = async (data: any): Promise<PutAdminCompaniesIdResponse> => {
    if (data.data) {
        data.data.createdAt = new Date(data.data.createdAt)
        data.data.updatedAt = new Date(data.data.updatedAt)
        if (data.data.archivedAt) {
            data.data.archivedAt = new Date(data.data.archivedAt)
        }
    }
    return data
}

export const patchAdminCompaniesIdArchiveResponseTransformer = async (data: any): Promise<PatchAdminCompaniesIdArchiveResponse> => {
    if (data.data.archivedAt) {
        data.data.archivedAt = new Date(data.data.archivedAt)
    }
    return data
}

const adminCompanyCreditLedgerEntrySchemaSchemaResponseTransformer = (data: any) => {
    data.createdAt = new Date(data.createdAt)
    return data
}

const adminCompanyCreditLedgerPayloadSchemaSchemaResponseTransformer = (data: any) => {
    data.rows = data.rows.map((item: any) => adminCompanyCreditLedgerEntrySchemaSchemaResponseTransformer(item))
    return data
}

const adminCompanyCreditLedgerApiResponseSchemaSchemaResponseTransformer = (data: any) => {
    data.data = adminCompanyCreditLedgerPayloadSchemaSchemaResponseTransformer(data.data)
    return data
}

export const getAdminCompaniesIdCreditsLedgerResponseTransformer = async (data: any): Promise<GetAdminCompaniesIdCreditsLedgerResponse> => {
    data = adminCompanyCreditLedgerApiResponseSchemaSchemaResponseTransformer(data)
    return data
}

const myCompanyPayloadSchemaSchemaResponseTransformer = (data: any) => {
    data.createdAt = new Date(data.createdAt)
    return data
}

const myCompaniesApiResponseSchemaSchemaResponseTransformer = (data: any) => {
    data.data.companies = data.data.companies.map((item: any) => myCompanyPayloadSchemaSchemaResponseTransformer(item))
    return data
}

export const getAuthMyCompaniesResponseTransformer = async (data: any): Promise<GetAuthMyCompaniesResponse> => {
    data = myCompaniesApiResponseSchemaSchemaResponseTransformer(data)
    return data
}

export const postCompanyConfigResponseTransformer = async (data: any): Promise<PostCompanyConfigResponse> => {
    if (data) {
        data.createdAt = new Date(data.createdAt)
        data.updatedAt = new Date(data.updatedAt)
    }
    return data
}

export const putCompanyConfigResponseTransformer = async (data: any): Promise<PutCompanyConfigResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    return data
}

export const getInterviewsResponseTransformer = async (data: any): Promise<GetInterviewsResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    return data
}

export const getInterviewsIdResponseTransformer = async (data: any): Promise<GetInterviewsIdResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    return data
}

export const putInterviewsIdResponseTransformer = async (data: any): Promise<PutInterviewsIdResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    return data
}

export const postInterviewsIdInterviewRoundResponseTransformer = async (data: any): Promise<PostInterviewsIdInterviewRoundResponse> => {
    if (data.data) {
        data.data.createdAt = new Date(data.data.createdAt)
        data.data.updatedAt = new Date(data.data.updatedAt)
    }
    return data
}

export const putInterviewsIdInterviewRoundResponseTransformer = async (data: any): Promise<PutInterviewsIdInterviewRoundResponse> => {
    if (data.data) {
        data.data.createdAt = new Date(data.data.createdAt)
        data.data.updatedAt = new Date(data.data.updatedAt)
    }
    return data
}

export const deleteInterviewsIdInterviewRoundInterviewRoundIdResponseTransformer = async (
    data: any
): Promise<DeleteInterviewsIdInterviewRoundInterviewRoundIdResponse> => {
    if (data.data) {
        data.data.createdAt = new Date(data.data.createdAt)
        data.data.updatedAt = new Date(data.data.updatedAt)
    }
    return data
}

export const patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponseTransformer = async (
    data: any
): Promise<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    return data
}

export const postJobApplicationsIdResponseTransformer = async (data: any): Promise<PostJobApplicationsIdResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    if (data.statusChangeDate) {
        data.statusChangeDate = new Date(data.statusChangeDate)
    }
    data.processingQueuedAt = new Date(data.processingQueuedAt)
    return data
}

export const getJobApproversResponseTransformer = async (data: any): Promise<GetJobApproversResponse> => {
    data = data.map((item: any) => {
        item.createdAt = new Date(item.createdAt)
        item.updatedAt = new Date(item.updatedAt)
        return item
    })
    return data
}

export const postJobApproversResponseTransformer = async (data: any): Promise<PostJobApproversResponse> => {
    data = data.map((item: any) => {
        item.createdAt = new Date(item.createdAt)
        item.updatedAt = new Date(item.updatedAt)
        return item
    })
    return data
}

export const getOffersResponseTransformer = async (data: any): Promise<GetOffersResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    if (data.startDate) {
        data.startDate = new Date(data.startDate)
    }
    return data
}

export const putOffersResponseTransformer = async (data: any): Promise<PutOffersResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    if (data.startDate) {
        data.startDate = new Date(data.startDate)
    }
    return data
}

export const getOffersApproveResponseTransformer = async (data: any): Promise<GetOffersApproveResponse> => {
    data.JobPosting.createdAt = new Date(data.JobPosting.createdAt)
    data.JobPosting.updatedAt = new Date(data.JobPosting.updatedAt)
    if (data.JobPosting.deletedAt) {
        data.JobPosting.deletedAt = new Date(data.JobPosting.deletedAt)
    }
    data.InterviewDetails = data.InterviewDetails.map((item: any) => {
        item.createdAt = new Date(item.createdAt)
        item.updatedAt = new Date(item.updatedAt)
        return item
    })
    data.Department.createdAt = new Date(data.Department.createdAt)
    data.Department.updatedAt = new Date(data.Department.updatedAt)
    return data
}

export const putOffersDocumentsResponseTransformer = async (data: any): Promise<PutOffersDocumentsResponse> => {
    data.data.createdAt = new Date(data.data.createdAt)
    data.data.updatedAt = new Date(data.data.updatedAt)
    if (data.data.startDate) {
        data.data.startDate = new Date(data.data.startDate)
    }
    return data
}

export const postSettingsCommunicationTemplatesResponseTransformer = async (data: any): Promise<PostSettingsCommunicationTemplatesResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    return data
}

export const getSettingsCommunicationTemplatesIdResponseTransformer = async (data: any): Promise<GetSettingsCommunicationTemplatesIdResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    return data
}

export const putSettingsCommunicationTemplatesIdResponseTransformer = async (data: any): Promise<PutSettingsCommunicationTemplatesIdResponse> => {
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    return data
}

export const getTemporalIntegrationsResponseTransformer = async (data: any): Promise<GetTemporalIntegrationsResponse> => {
    if (data.lastVerifiedAt) {
        data.lastVerifiedAt = new Date(data.lastVerifiedAt)
    }
    data.createdAt = new Date(data.createdAt)
    data.updatedAt = new Date(data.updatedAt)
    return data
}

export const getTemporalScreeningCallResponseTransformer = async (data: any): Promise<GetTemporalScreeningCallResponse> => {
    if (data.scheduledAt) {
        data.scheduledAt = new Date(data.scheduledAt)
    }
    return data
}

export const putTemporalScreeningCallResponseTransformer = async (data: any): Promise<PutTemporalScreeningCallResponse> => {
    data.screeningCall.createdAt = new Date(data.screeningCall.createdAt)
    data.screeningCall.updatedAt = new Date(data.screeningCall.updatedAt)
    if (data.screeningCall.scheduledAt) {
        data.screeningCall.scheduledAt = new Date(data.screeningCall.scheduledAt)
    }
    return data
}
